export default __webpack_public_path__ + "static/media/green-standing-raccoon.eb21b2cd.jpg";